import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    window
      .$(document)
      .on("click", "#urgent-notifications .dismiss", function () {
        window.$("#urgent-notifications").hide();
      });
    // Open/close timing sourced from the shared motion tokens
    // (motion_tokens.scss) instead of Fomantic's default (500ms both
    // ways), matching the toast recipe's own open-slower/close-faster
    // asymmetry: opening is deliberate, dismissing gets out of the way.
    // motion_tokens.scss doesn't collapse these centrally (see that file) -
    // every consumer checks prefers-reduced-motion itself, matching the
    // per-component convention the rest of the app already uses.
    const motionTokens = getComputedStyle(document.documentElement);
    const reduceMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const toastOpenMs = reduceMotion
      ? 0.01
      : parseFloat(motionTokens.getPropertyValue("--duration-medium")) || 350;
    const toastCloseMs = reduceMotion
      ? 0.01
      : parseFloat(motionTokens.getPropertyValue("--duration-fast")) || 250;
    // closeEasing governs the auto-dismiss slide (a jQuery.easing keyword,
    // confirmed live via $.fn.toast.settings.transition.closeEasing -
    // Fomantic's own default is "easeOutCubic", not our --ease-smooth-out).
    // window.ikRegisterMotionEasing (application.js) registers the shared
    // easing once per page and is idempotent, so it's safe to call again
    // here regardless of script load order between the two bundles.
    const closeEasing =
      (window.ikRegisterMotionEasing && window.ikRegisterMotionEasing()) ||
      "easeOutCubic";

    window.$("#flash-alerts .ui.message").each(function () {
      window.$(this).removeClass("hidden");
      window.$("body").toast({
        class: window.$(this).attr("class"),
        displayTime: 10000,
        showIcon: false,
        closeIcon: true,
        message: window.$(this).html(),
        // Bottom, as the React shell does: page headers keep their controls on top.
        position: "bottom center",
        className: {
          toast: "ui message floating fluid padding-xy-small",
        },
        transition: {
          showDuration: toastOpenMs,
          hideDuration: toastCloseMs,
          closeDuration: toastCloseMs,
          closeEasing,
        },
      });
      window.$(this).remove();
    });
  }
}
